import { OperationType } from './../../../widgets/filters/miscellaneous/operation-type.enum';
import { QueryFilterParameter } from './../../../widgets/filters/models/query-filter-parameter.model';
import { HelpService } from './../../help/help.service';
import { Title } from '@angular/platform-browser';
import { DxChartComponent, DxRangeSelectorComponent } from "devextreme-angular";
import { DropdowndSelectedValues } from "./../../../widgets/dropdown-filter/dropdown-filter.component";
import {
  OverviewUnitOfMeasure,
  OverviewFiltersOutput,
  TaskDataFilter
} from "./../stock.service";
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { StockService, OverviewFilterInput } from "../stock.service";
import { HtmlControlType } from "src/app/enums/htmlControlType";
import { SettingsService } from "../../settings/settings.service";
import { DevTooltipCustComponent } from 'src/app/widgets';
import { ShareDataService } from 'src/app/services/share-data.service';
import { ActivatedRoute } from '@angular/router';
import { TaskService } from '../../task/task.service';
import { FilterInput, ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { BookmarkData } from 'src/app/models/Bookmark';
import { FileExportService } from 'src/app/common/file-export-service';

@Component({
  selector: "app-stock-overview",
  templateUrl: "./stock-overview.component.html",
  styleUrls: ["./stock-overview.component.scss"],
  standalone: false
})
export class StockOverviewComponent implements OnInit, AfterViewInit {
  filterOptions: OverviewFiltersOutput;
  allFilters: OverviewFilterInput[] = [];
  filterList: OverviewFilterInput[] = [];
  resetFiltersItems: string[] = [];

  //chart value range
  visualRange: any = {};
  firstChartDataSource: any = {};
  secondChartDataSource: any = {};
  tableDataSource: any = {};

  currency = "";
  currencyTitle = "Stock Development";
  currencysecondTitle = "";
  period = "period";

  //Some data for titles
  titleData: OverviewUnitOfMeasure;

  action = "Filter";
  htmlControlType = HtmlControlType;

  @ViewChild("firstChartContainer", { static: false })
  firstChartContainer: ElementRef;
  firstChartContainerWidht = 0;

  @ViewChild("stockDevelopmentChart", { static: false })
  stockDevChart: DxChartComponent;
  @ViewChild("potentialByIssue", { static: false })
  potByIssue: DxChartComponent;

  @ViewChild("stockDevelopmentChartRangSelct", { static: false }) stockDevChartChartRangSelct: DxRangeSelectorComponent;

  isPageLoad: boolean = false;

  constructor(
    private stockService: StockService,
    private settingsService: SettingsService,
    private helpService: HelpService,
    private titleService: Title, private shareDataService: ShareDataService,
    private route: ActivatedRoute, private taskService: TaskService, private fileExportService: FileExportService
  ) {
    this.shareDataService.CleanData();
  }

  ngAfterViewInit(): void {
    setTimeout(
      () =>
      (this.firstChartContainerWidht = this.firstChartContainer
        ? this.firstChartContainer.nativeElement.offsetWidth
        : 0)
    );
  }

  taskFilterData: TaskDataFilter[];
  IsTaskLoad = false;
  ngOnInit() {
    this.titleService.setTitle("Stock Overview");

    this.route.paramMap.subscribe(
      params => {
        const value = this.route.snapshot.queryParamMap.get("taskid");
        if (value) {

          //default load with parameters
          this.filterOptions = new OverviewFiltersOutput();
          this.filterOptions.action = this.action;
          this.filterOptions.settingGroupId = 1;
          this.filterOptions.filters = [];

          //loading filter data

          this.taskService.SelectTaskFilterValues(value).subscribe(data => {
            this.taskFilterData = data;
            this.taskFilterData.forEach(element => {
              let filteItem: QueryFilterParameter = new QueryFilterParameter(
                element.fieldName,
                element.settingValue,
                OperationType.Contains
              );

              this.filterOptions.filters.push(filteItem);
            });
            this.IsTaskLoad = true;
            this.getFiltersData();
          }, err => {

          });

        }
        else {
          this.dataFilter = new BookmarkData();
          this.dataFilter.BookmarkId = 0;
          this.dataFilter.name = "DefBokmk";
          this.dataFilter.pageName = this.pageName;
          this.loadBookMarkFilter();
        }
      });

    this.GetSettingsData();
    this.WebSettingsPivot();
    this.WebSettingsTitle();

  }

  Currency: any;
  WebSettingsTitle() {
    this.settingsService.WebMulSettings("StockUoMTitle").subscribe((res) => {
      this.Currency = res;
    });
  }

  getCurrency() {
    if (this.filterList != null) {
      for (var i = 0; i < this.filterList.length; i++) {
        if (this.filterList[i].selectionName.toLowerCase() == 'unitofmeasure' && this.filterList[i].selectedValues != null && this.filterList[i].selectedValues.length > 0) {
          var filterData = this.Currency.filter(x => x.stockUnitValue == this.filterList[i].selectedValues[0]);
          var DfilterData = this.Currency.filter(x => x.stockUnit == 'DefaultTitle');
          if (filterData != null && filterData.length > 0) {
            this.currencyTitle = "Stock Development (Value " + filterData[0].stockUnitTitleValue + ")";
          }
          else if (DfilterData != null && DfilterData.length > 0) {
            this.currencyTitle = "Stock Development (" + DfilterData[0].stockUnitTitleValue + ")";
          }
          else {
            this.currencyTitle = "Stock Development";
          }
        }
      }
    }
  }

  private getData() {
    this.stockService
      .getOverviewData(this.filterOptions)
      .toPromise()
      .then((data) => {
        if (data) {
          this.tableDataSource = data.stockControllingData;

          data.stockDevelopmentChart.forEach((item) => (item.yearWeek += " "));
          this.firstChartDataSource = data.stockDevelopmentChart;
          this.secondChartDataSource = data.stockControllingData;
          this.titleData = data.unitOfMeasureData[0];
          this.LoadChartSeries();
        } else {
          this.tableDataSource = [];
          this.firstChartDataSource = [];
          this.secondChartDataSource = [];
          this.titleData = null;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  sortValues(values) {
    values.sort((first, second) => (first.issue > second.issue ? -1 : 1));
  }

  onResize() {
    setTimeout(() => {
      this.LoadChartSeries();
      this.firstChartContainerWidht = this.firstChartContainer
        ? this.firstChartContainer.nativeElement.offsetWidth
        : 0;
      this.stockDevChart.instance.refresh();
      this.potByIssue.instance.refresh();
      if (this.stockDevChartChartRangSelct && this.stockDevChartChartRangSelct.instance) {
        this.stockDevChartChartRangSelct.instance.render();
      }
    });
  }

  onLegendClick(e: any) {
    const series = e.target;
    if (series.isVisible()) {
      series.hide();
    } else {
      series.show();
    }
    this.loadLengendToShare();
  }

  private initFilterOptions() {
    this.filterOptions = new OverviewFiltersOutput();
    this.filterOptions.action = this.action;
    this.filterOptions.settingGroupId = 1;
    this.filterOptions.filters = [];
    this.getFiltersData();
  }

  private getFiltersData() {
    this.loadLengendToShare();
    this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.filterOptions.filters);
    this.stockService.getOverviewFilters(this.filterOptions.filters).subscribe(
      (res) => {
        //convert received data to table structure for drop down

        console.log(this.filterOptions.filters);
        res.forEach((item) => {
          item.values = item.values ? item.values : [];
          this.filterOptions.filters = this.filterOptions.filters
            ? this.filterOptions.filters
            : [];

          item.values = item.values.map((all) => ({ all }));
          item.selectedValues = this.filterOptions.filters
            .filter((filterItem) => filterItem.fieldName === item.selectionName)
            .map((filterItem) => filterItem.value);
          if (item.defaultFilterValue != null && item.defaultFilterValue != '' && item.values.length > 0 && this.isPageLoad) {
            item.selectedValues = [item.defaultFilterValue];
          }
        });
        this.allFilters = res;
        this.filterList = res;

        if (this.isPageLoad) {
          this.isPageLoad = false;
          this.filterOptions.filters = [];
          this.filterList.forEach((item) => {
            if (item.selectedValues != null && item.selectedValues.length > 0) {
              item.selectedValues.forEach(element => {
                let filteItem: QueryFilterParameter = new QueryFilterParameter(
                  item.selectionName,
                  element,
                  OperationType.Contains
                );
                this.filterOptions.filters.push(filteItem);
              });
            }
          });
        }
        this.getCurrency();
        this.getData();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  setTextBoxFilterOptions(selectionId: number, el: any) {
    if (el.value) {
      this.filterList.forEach((item) => {
        if (item.selectionId === selectionId) {
          let arr: string[] = [];
          arr.push(el.value);
          item.selectedValues = arr;
        }
      });
    }
  }

  setDropDownFiltersOptions(event: any) { }

  applyFilters() {
    let filters: QueryFilterParameter[] = [];

    if (this.filterOptions.filters) {
      this.filterList.forEach((item) => {
        if (item.selectedValues && item.selectedValues.length > 0) {
          item.selectedValues.forEach((el) => {
            let filter = new QueryFilterParameter(
              item.selectionName,
              el,
              OperationType.Equals
            );

            filters.push(filter);
          });
        }
      });
    }

    this.filterOptions.filters = filters;
    this.shareDataService.CleanData();
    this.shareDataService.filterOptionOverview = this.filterOptions;


    this.getFiltersData();

  }

  resetFilters() {
    this.filterOptions.filters = [];
    this.filterList.map((item) => (item.selectedValues = []));
    this.filterList.forEach((item) => {
      if (item.defaultFilterValue) {
        item.selectedValues = [item.defaultFilterValue];
      } else {
        item.selectedValues = [];
      }
    });
    this.ChartSettings = null;
    this.applyFilters();
    this.resetFiltersItems = [];
    this.currentlySelectedFilters = [];
  }

  customizeDate(): string {
    return "Grand Total";
  }


  //adding customize setting with title, change title if need.
  customizeTooltip = (info: any) => {
    return DevTooltipCustComponent.customizeTooltip(info, this.currencyTitle, "", "");
  }

  selectedItemsChanged(event: DropdowndSelectedValues) {
    this.filterList
      .filter((item) => item.selectionId === event.selectionId)
      .forEach((item) => (item.selectedValues = event.values));
  }

  public onHelpButtonClicked(event, settingName: string) {
    this.helpService.openHelpPage(settingName);
  }

  //bookmark
  pageName: string = "StockOverview";
  currentlySelectedFilters: FilterInput[] = [];
  dataFilter: BookmarkData;

  loadBookMarkFilterClick(data) {
    if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
      this.filterOptions.filters = [];
      this.filterList.map(item => item.selectedValues = []);
      this.resetFiltersItems = [];
      this.currentlySelectedFilters = [];
      this.dataFilter = new BookmarkData();
      this.dataFilter.BookmarkId = data.bookmarkId;
      this.dataFilter.name = "Bokmk";
      this.dataFilter.pageName = this.pageName;
      this.loadBookMarkFilter();
    }
  }

  loadBookMarkFilter() {

    var filterData = Object.assign({}, this.dataFilter);
    filterData.name = "BokmkN";
    this.ChartSettings = null;
    this.taskService.LoadBookmarkData(filterData).subscribe(RData => {
      if (RData != null && RData.table != null && RData.table.length > 0) {
        this.IsTaskLoad = false;
        if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != "") {
          this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
        }
        this.onResize();
        this.LoadChartSeries();
        this.loadLengendToShare();
        this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
          this.taskFilterData = data;
          //default load with parameters
          this.filterOptions = new OverviewFiltersOutput();
          this.filterOptions.action = this.action;
          this.filterOptions.settingGroupId = 1;
          this.filterOptions.filters = [];
          this.taskFilterData.forEach(element => {
            let filteItem: QueryFilterParameter = new QueryFilterParameter(
              element.fieldName,
              element.settingValue,
              OperationType.Contains
            );

            this.filterOptions.filters.push(filteItem);
            this.shareDataService.filterOptionOverview = this.filterOptions;
          });
          this.IsTaskLoad = true;
          this.getFiltersData();
        }, err => {
        });
      }
      else {
        this.isPageLoad = true;
        this.initFilterOptions();
      }
    }, err => {
    });
  }

  /* Export Forecast Option */
  IsExportEnable = false;
  GetSettingsData() {
    this.fileExportService.WebSettings("EnableExportStockOverview").subscribe(resultFilename => {
      this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
    }, err => {
      console.log(err);
    });
  }

  //tooltip
  EnableTooltip = false;
  ShowTooltip: boolean = false;
  WebSettingsPivot() {
    this.fileExportService.WebSettingsPivot("actionpivotStockOverview").subscribe(result => {
      console.log(result);
      if (result != null && result.length > 0 && result[0].defaultSelectionTooltipStockOverview != null
        && result[0].defaultSelectionTooltipStockOverview.toLowerCase() == "yes") {
        this.EnableTooltip = true;
      }
      if (result != null && result.length > 0 && result[0].enableDisableTooltipStockOverview != null
        && result[0].enableDisableTooltipStockOverview.toLowerCase() == "yes") {
        this.ShowTooltip = true;
      }

    }, err => {
      console.log(err);
    });
  }

  loadLengendToShare() {
    var seriesValues = { StockDevelopment: [] };
    if (this.stockDevChart != null && this.stockDevChart.instance != null
      && this.stockDevChart.instance.getAllSeries() != null) {
      this.stockDevChart.instance.getAllSeries().forEach(item => {
        if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
          seriesValues.StockDevelopment.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
        }
      })
    }
    this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
  }

  ChartSettings: any;
  LoadChartSeries() {
    if (Array.isArray(this.stockDevChart.series) && this.stockDevChart.series.length > 0) {
      for (let index = 0; index < this.stockDevChart.series.length; index++) {
        this.stockDevChart.series[index].visible = true;
      }
    }

    if (this.ChartSettings != null) {

      if (this.ChartSettings.StockDevelopment != null && this.ChartSettings.StockDevelopment.length > 0) {
        if (this.stockDevChart != null && this.stockDevChart.series != null
          && Array.isArray(this.stockDevChart.series) && this.stockDevChart.series.length > 0) {
          for (let index = 0; index < this.stockDevChart.series.length; index++) {
            this.ChartSettings.StockDevelopment.forEach(itemchrt => {
              if (this.stockDevChart.series[index].valueField != null
                && itemchrt.isVisible != null && (this.stockDevChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
                  || this.stockDevChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
              ) {
                this.stockDevChart.series[index].visible = itemchrt.isVisible;
              }
            });
          }
        }
      }
    }
  }
  filterMappingService = new FilterMappingService();
  ExportToExcelFilters: ExportFilter[] = [];
}
